module.exports = __webpack_public_path__ + "static/media/icon.85e6a5d3.svg";